import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedModule } from '../~shared/modules/shared.module';

@Component({
  selector: 'not-found',
  imports: [SharedModule],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundComponent {}
